import { motion } from "framer-motion";
import Overline from "./Overline";
import { reveal, VIEW_80 } from "./motion";

export const AboutVision = () => (
  <section data-testid="about-vision" className="px-6 py-28 md:px-16 lg:px-24">
    <motion.div
      variants={reveal}
      initial="hidden"
      whileInView="show"
      viewport={VIEW_80}
      className="relative overflow-hidden rounded-3xl border border-white/10 bg-[#12141C]/55 p-10 shadow-[0_8px_40px_rgba(0,0,0,0.45)] backdrop-blur-2xl md:p-16"
    >
      <div className="pointer-events-none absolute -right-16 -top-16 h-44 w-44 rounded-full border border-[#8B5CF6]/40 [animation:spin_18s_linear_infinite]" />
      <div className="pointer-events-none absolute -bottom-12 -left-12 h-32 w-32 rotate-45 border border-[#D4AF37]/30 [animation:spin_26s_linear_infinite_reverse]" />
      <Overline>Vision</Overline>
      <h2 className="font-display max-w-4xl text-3xl font-bold leading-tight text-[#F4F6FB] md:text-5xl">
        A web you don't just read —{" "}
        <span className="bg-gradient-to-r from-[#8B5CF6] via-[#06B6D4] to-[#D4AF37] bg-clip-text text-transparent">
          a web you step into.
        </span>
      </h2>
      <p className="mt-8 max-w-2xl text-sm leading-relaxed text-[#F4F6FB]/60 md:text-base">
        Screens are becoming spaces. As browsers learn to render worlds in real time, the
        brands that matter will be the ones that feel like destinations. Elentara exists to
        build that future early — immersive, performant, and open to everyone, on any device.
      </p>
    </motion.div>
  </section>
);

export default AboutVision;
